/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Line2Inputs */

const zh_landing_hero_line2 = /** @type {(inputs: Landing_Hero_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备课更少。`)
};

const en_landing_hero_line2 = /** @type {(inputs: Landing_Hero_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prepare less.`)
};

const es_landing_hero_line2 = /** @type {(inputs: Landing_Hero_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prepara menos.`)
};

/**
* | output |
* | --- |
* | "prepare less." |
*
* @param {Landing_Hero_Line2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_hero_line2 = /** @type {((inputs?: Landing_Hero_Line2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Line2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_hero_line2(inputs)
	if (locale === "en") return en_landing_hero_line2(inputs)
	return es_landing_hero_line2(inputs)
});